<template>
  <div>
    <img
      id="mySpinner"
      src="loading.gif"
      v-if="loading"
      class="center-block"
    />

    <nav
      class="navbar navbar-default navbar-options"
      role="navigation"
      v-if="aberto && !loading && invoice && !showErrorModal"
    >
      <div class="container">
        <div class="navbar-header">
          <div class="back-button">
            <span class="restaurantname">
              {{ restaurantName }}</span>
          </div>
        </div>
      </div>
    </nav>

    <transition
      name="modal"
      v-if="showErrorModal && !loading"
    >
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-body">
              <slot name="body">
                <span class="steps-subtitle">Seu código Pix expirou</span>
                <br>
                <span class="steps-text">Selecione uma nova forma de pagamento...</span>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button
                  class="modal-default-button"
                  @click="newPaymentMethod()"
                >
                  Ok!
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition
      name="modal"
      v-if="showModal && !loading && !showErrorModal"
    >
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-header">
              <slot name="header">
                <h4>Pagar com Pix</h4>
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                <span class="steps-subtitle">1º passo</span>
                <br>
                <span class="steps-text">Copie o código que foi gerado</span>
                <br>
                <span class="steps-subtitle">2º passo</span>
                <br>
                <span class="steps-text">Abra o aplicativo em que deseja realizar o pagamento e use a opção Pix Copia e Cola</span>
                <br>
                <span class="steps-subtitle">3º passo</span>
                <br>
                <span class="steps-text">Cole o código, confirme seu o valor e faça o pedido</span>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button
                  class="modal-default-button"
                  @click="showModal = false"
                >
                  Entendi!
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="aberto && !loading && invoice && !showErrorModal && totalValue">
      <h2 style="display: flex; justify-content: center; justify-items: center">Total a pagar:</h2>
      <br />
      <h1 class="price-container">
        {{ totalValue }}
      </h1>
      <br />
      <div>
        <h4 class="qrTitle">Pague com o Pix Copia e Cola</h4>
        <span class="qrSubTitle"> Para realizar o pagamento, copie o código abaixo e utilize no aplicativo de pagamento.</span>
      </div>
      <br />
      <div v-if="invoice">
        <span class="qrSubTitle">Código pix expira em: 0{{ minutes }}:<span v-if="seconds < 10">0</span>{{ seconds }}</span>
      </div>
      <br />
      <div class="pix-input-container">
        <input
          type="text"
          :value="pixCode"
          class="qrcode-input-text center-block"
        >
        <button
          :value="pixCode"
          class="input-btn-qr-code"
          id="qrCodeBtn"
          type="button"
          @click.prevent="copyURL"
          @focus="copyText"
          @blur="changeText"
        >
          <img
            src="/assets/copy-icon.png"
            alt="copy"
            class="copy-img-container"
          >
        </button>
      </div>
      <br />
      <button
        :value="pixCode"
        class="btn btn-lg btn-qr-code center-block"
        id="qrCodeBtn"
        type="button"
        @click.prevent="copyURL"
        @focus="copyText"
        @blur="changeText"
      >
        <div
          class="show"
          id="btnText"
        > Copiar Código</div>
        <div
          class="btn-qr-code-text"
          id="qrCodeText"
        > Copiado! </div>
      </button>
    </div>
    <br />
    <div v-if="invoice && !showErrorModal">
      <span
        class="payment-fail-text"
        v-if="orderStatus === 'ATIVA'"
      >Aguardando pagamento</span>
      <span
        class="payment-success-text"
        v-if="orderStatus === 'CONCLUIDA'"
      >Pagamento confirmado!</span>
    </div>
  </div>
</template>

<script>
import { formatDistanceStrict } from 'date-fns'

export default {
  name: 'InvoicePayment',
  data () {
    return {
      loading: false,
      showModal: false,
      showErrorModal: false,
      session: {},
      invoice: null,
      totalValue: null,
      now: new Date(),
      expireAt: null,
      pixTimer: null,
      orderStatus: 'ATIVA',
      interval: null,
      seconds: null,
      minutes: null,
      errorMessage: null
    }
  },
  computed: {
    aberto: {
      get () {
        return this.$store.state.aberto
      },
      set (value) {
        this.$store.commit('setAberto', value)
      }
    },
    token () {
      return this.$store.state.token
    },
    pixCode () {
      return this.$store.state.pixCode
    },
    txid () {
      return this.$store.state.txid
    },
    channelId () {
      return this.$store.state.channelId
    },
    clientId () {
      return this.$store.state.clientId
    },
    code () {
      return this.$store.state.code
    },
    demo () {
      return this.$store.state.demo
    },
    restaurantName () {
      return this.$store.state.restaurantName
    },
    location () {
      return this.$store.state.location
    },
    slug () {
      return this.$store.state.slug
    }
  },
  mounted () {
    const vm = this

    if (vm.orderStatus === 'CONCLUIDA') vm.goToMenu()

    if (vm.txid !== null && vm.orderStatus === 'ATIVA') {
      vm.init()
    }
  },
  methods: {

    init () {
      const vm = this
      vm.loading = true
      vm.showModal = true

      vm.axios
        .get(`${process.env.VUE_APP_API_URL}/sessions`, {
          headers: {
            Authorization: vm.token
          }
        })
        .then(response => {
          vm.session = response.data
          vm.getPaymentDetails()
          vm.loading = false
        })
    },

    getPaymentDetails () {
      const vm = this

      vm.axios
        .get(`${process.env.VUE_APP_API_URL}/payments/pix/${vm.txid}`,
          {
            headers: {
              Authorization: vm.token
            }
          })
        .then(response => {
          if (response.data) {
            vm.invoice = response.data
            vm.totalValue = (vm.invoice.totalCents / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            vm.orderStatus = vm.invoice.status
            vm.timeToExpire()
            this.interval = setInterval(this.checkPayment, 5000)
            vm.loading = false
          } else {
            return vm.goToMenu()
          }
        })
    },

    checkPayment () {
      const vm = this

      vm.axios
        .get(`${process.env.VUE_APP_API_URL}/payments/pix/${vm.txid}`,
          {
            headers: {
              Authorization: vm.token
            }
          })
        .then(response => {
          vm.orderStatus = response.data.status
          const STATUS_PAID = ['PAID', 'CONFIRMED']
          if (STATUS_PAID.includes(vm.orderStatus)) {
            vm.loading = true
            clearInterval(vm.interval)
            return vm.goToHistory()
          }
        })
    },

    timeToExpire () {
      const vm = this
      vm.expireAt = new Date(vm.invoice.pix.calendario.expiration)
      vm.pixTimer = formatDistanceStrict(
        vm.now,
        vm.expireAt,
        { unit: 'minute' }
      )
      vm.pixTimer = vm.pixTimer.split(' ')
      vm.pixTimer = parseInt(vm.pixTimer[0])

      vm.seconds = 0
      vm.minutes = vm.pixTimer

      if ((vm.now > vm.expireAt) || (vm.seconds === 0 && vm.minutes === 0)) {
        vm.showErrorModal = true
        return vm.showErrorModal
      }
      setInterval(() => {
        if (vm.seconds === 0 && vm.minutes === 0) {
          vm.showErrorModal = true
          return vm.showErrorModal
        }
        if (vm.seconds === 0) {
          vm.seconds = 59
          vm.minutes--
        }
        vm.seconds--
      }, 1000)
    },

    goToMenu () {
      const vm = this

      clearInterval(vm.interval)

      if (vm.code) {
        return vm.$router.push({
          path: `/${vm.code}`
        })
      }
      if (vm.channelId && vm.clientId) {
        return vm.$router.push({
          path: `/menu/${vm.channelId}/${vm.clientId}`
        })
      }
      if (vm.location && vm.slug) {
        return vm.$router.push({
          path: `/delivery/${vm.location}/${vm.slug}`
        })
      }
    },

    newPaymentMethod () {
      const vm = this

      clearInterval(vm.interval)

      if (vm.code) {
        return vm.$router.push({
          path: `/${vm.code}/payment`
        })
      }
      if (vm.channelId && vm.clientId) {
        return vm.$router.push({
          path: `/payment/${vm.channelId}/${vm.clientId}`
        })
      }
      if (vm.location && vm.slug) {
        return vm.$router.push({
          path: `/delivery/${vm.location}/${vm.slug}/payment`
        })
      }
    },

    copyURL () {
      var dummy = document.createElement('input')
      document.body.appendChild(dummy)
      dummy.value = this.pixCode
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)
      document.getElementById('qrCodeBtn').focus()
    },

    copyText () {
      var btn = document.getElementById('qrCodeBtn')
      var div = document.getElementById('qrCodeText')
      var btnText = document.getElementById('btnText')
      div.className = 'show break-url'
      btnText.className = 'btn-text'

      setTimeout(function () { btn.blur() }, 2000)
    },

    changeText () {
      var div = document.getElementById('qrCodeText')
      var btnText = document.getElementById('btnText')
      div.className = 'btn-qr-code-text'
      btnText.className = 'show'
    },

    closeWebview () {
      try {
        window.MessengerExtensions.requestCloseBrowser(null, null)
      } catch (e) {
        console.log('MessengerExtensions not supported')
      }
    },

    goToHistory () {
      const vm = this

      this.$store.commit('setPixCode', null)
      this.$store.commit('setTxId', null)

      if (vm.code) {
        // Whats
        vm.$router.push({
          path: `/${vm.code}/history`
        })
      } else if (vm.channelId && vm.clientId) {
        // Messenger
        vm.closeWebview()
      } else {
        // Site
        vm.$router.push({
          path: `/delivery/${vm.location}/${vm.slug}/history`
        })
      }
    }
  }
}
</script>

<style>
.price-container {
  display: flex;
  justify-content: center;
  justify-items: center;
  font-size: 32px;
}
.pix-img-container {
  max-width: 250px;
  max-height: 250px;
}
.copy-img-container {
  width: 20px;
  height: 20px;
}
.pix-input-container {
  display: flex;
  flex-direction: row;
  border: dashed 1px black;
  margin: 0 20px;
  border-radius: 5px;
  min-height: 40px;
  overflow: hidden;
}
.qrcode-input-text {
  border: none;
  max-width: fit-content;
  font-size: 20px;
  text-overflow: ellipsis;
  border-radius: 5px;
}
.qrcode-input-text:focus {
  outline: none;
}
.input-btn-qr-code {
  white-space: normal;
  justify-content: center;
  border: none;
  background-color: white;
  outline: none !important;
  border-style: none;
  border-radius: 0;
  box-shadow: none !important;
  margin-right: 20px;
}
.btn-qr-code {
  white-space: normal;
  justify-content: center;
  width: 188px;
  border: none;
  outline: none !important;
  border-style: none;
  border-radius: 0;
  box-shadow: none !important;
}
button.btn-qr-code:focus {
  white-space: normal;
  justify-content: center;
  width: 188px;
  border: none;
  outline: none !important;
  border-style: none;
  border-radius: 0;
  box-shadow: none !important;
}
button.btn-qr-code:active {
  white-space: normal;
  justify-content: center;
  width: 188px;
  border: none;
  outline: none !important;
  border-style: none;
  border-radius: 0;
  box-shadow: none !important;
}
.qrTitle {
  display: flex;
  font-size: 22px;
  justify-content: center;
}
.qrSubTitle {
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 5px 5px;
}
.payment-fail-text {
  color: #e74c3c;
  display: flex;
  font-size: 18px;
  justify-content: center;
  text-align: center;
}
.payment-success-text {
  color: #5cb85c;
  display: flex;
  font-size: 18px;
  justify-content: center;
  text-align: center;
}
.btn-text {
  display: none;
}
.btn-qr-code-text {
  display: none;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 10px 0 5px 0;
}
.steps-subtitle {
  font-weight: bold;
  color: #e74c3c;
}
.steps-text {
  font-weight: lighter;
  color: dimgray;
}

.modal-footer {
  display: flex;
  justify-content: center;
  justify-items: center;
}
.modal-default-button {
  background-color: #e74c3c;
  color: white;
  font-size: 16px;
  border: 1px outset #e74c3c;
  font-weight: bold;
  border-radius: 5px;
  max-width: 200px;
  max-height: 40px;
  padding: 5px 10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
